import { object, string } from "yup";

export type FormValues = {
  userTag?: string | null;
  description?: string | null;
};

export const validationSchema = object({
  userTag: string().notRequired().nullable(),
  description: string().notRequired().nullable(),
});
